module.exports = __webpack_public_path__ + "static/media/InactiveIcon.9ceedb2c.png";